import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "13",
  fill: "none",
  viewBox: "0 0 12 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.6 4.8C6.923 4.8 8 3.723 8 2.4S6.923 0 5.6 0a2.403 2.403 0 0 0-2.4 2.4c0 1.323 1.077 2.4 2.4 2.4m5.916 2.99-.905-.905-1.81 1.81-1.812-1.81-.905.905 1.81 1.81-1.81 1.81.905.905 1.811-1.81 1.811 1.81.905-.905-1.81-1.81zM5.663 12.8H2.56c-.8 0-1.54-.364-2.027-.997a2.55 2.55 0 0 1-.45-2.213l.463-1.758A1.92 1.92 0 0 1 2.403 6.4h3.26l-.484.484a1.28 1.28 0 0 0 0 1.811l.905.905-.905.905a1.28 1.28 0 0 0 0 1.811z"
    }, null, -1)
  ])))
}
export default { render: render }